import { render, staticRenderFns } from "./SettingsGeneralTab.vue?vue&type=template&id=28df80fc"
import script from "./SettingsGeneralTab.vue?vue&type=script&lang=ts"
export * from "./SettingsGeneralTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports